import { split } from 'lodash-es'
import { LoadingView } from '@/composables/LoadingView'
import type { LoginResult } from '@/types/interface'

export const useLogin = () => {
  const router = useRouter()
  const { isTelegram, telegramWebApp } = useTelegram()

  const _loadingInstance = LoadingView.getInstance()
  /**
   * @description 初始化邀请参数
   */
  const initInvitorDomain = () => {
    const params = useUrlSearchParams('history')
    const params1 = useUrlSearchParams('hash')
    // 创作者邀请 链接
    if (params.invitorDomain || params1.invitorDomain) {
      Cookie.set('invitorDomain', params.invitorDomain || params1.invitorDomain, {
        expires: 5 * 365,
        domain: '.dfans.co',
      })
      Cookie.set('invitorDomain', params.invitorDomain || params1.invitorDomain, {
        expires: 5 * 365,
        domain: '.dfans.xyz',
      })
    }
    if (params.ref || params1.ref) {
      Cookie.set('invitorDomain', params.ref || params1.ref, {
        expires: 5 * 365,
        domain: '.dfans.co',
      })
      Cookie.set('invitorDomain', params.ref || params1.ref, {
        expires: 5 * 365,
        domain: '.dfans.xyz',
      })
    }

    // promotionTag 为运营推广注册标识
    if (params.promotionTag || params1.promotionTag) {
      Local.set('promotionTag', params.promotionTag || params1.promotionTag)
    }
    // 粉丝邀请粉丝
    if (params.inviter || params1.inviter) {
      Local.set('inviter', (params.inviter || params1.inviter).toString())
    }

    // tag 关联推广
    if (params.curated || params1.curated) {
      Local.set('curated', (params.curated || params1.curated).toString())
    }
  }

  /**
   * @description 登录后跳转
   */
  const loginJump = () => {
    Local.remove('inviter')
    Cookie.remove('invitorDomain', { domain: '.dfans.co' })
    Cookie.remove('invitorDomain', { domain: '.dfans.xyz' })
    Local.remove('promotionTag')
    Local.remove('curated')
    Cookie.remove('fromDomain')
    GlobalThis.$loginModalNew?.close()

    const redirectUrl = router.currentRoute.value?.query?.redirect || Session.get('redirectUri')

    if (redirectUrl) {
      // 检查是否是完整的 URL
      if (redirectUrl.startsWith('http') || redirectUrl.startsWith('https')) {
        // 解析 URL，只获取路径部分
        const url = new URL(redirectUrl)
        router.replace(url.pathname + url.search)
      } else if (redirectUrl.indexOf('becomeCreatorIntro') > -1) {
        router.replace({ name: 'BecomeCreator' })
      } else {
        // 确保 redirectUrl 不以 / 开头
        const path = redirectUrl.startsWith('/') ? redirectUrl.slice(1) : redirectUrl
        router.replace(`/${path}`)
      }
    } else {
      router.replace({ name: 'Home' })
    }

    setTimeout(() => {
      Session.remove('redirectUri')
    }, 500)
  }

  /**
   * @description 邀请上报
   */
  const clickShareLink = async () => {
    const inviter = Local.get('inviter')
    const inviterDomain = Cookie.get('invitorDomain')
    const promotionTag = Local.get('promotionTag')
    const curated = Local.get('curated')
    const fromDomain = Cookie.get('fromDomain')
    if (inviterDomain || inviter || promotionTag || curated || fromDomain) {
      try {
        await walletService.clickShareLink({
          inviterDomain,
          inviter,
          promotionTag,
          type: Local.get('loginType'),
          promoteKeys: curated,
          fromDomain,
        })
        loginJump()
      } catch (error) {
        console.error(error)
      }
    } else {
      loginJump()
    }
  }

  /**
   * @description 处理 Telegram 环境 参数
   */
  const initTGParams = () => {
    if (!isTelegram) return
    const result: any = {}
    const { start_param } = telegramWebApp?.initDataUnsafe
    if (start_param) {
      const pairs = split(start_param, '_')
      for (let i = 0; i < pairs.length; i += 2) {
        const key = pairs[i]
        const value = pairs[i + 1]
        if (key && value) {
          result[key] = value
        }
      }
    }
    if (result?.ref) {
      Cookie.set('invitorDomain', result.ref, { expires: 5 * 365, domain: '.dfans.co' })
      Cookie.set('invitorDomain', result.ref, { expires: 5 * 365, domain: '.dfans.xyz' })
    }
    if (result?.promotionTag) {
      Local.set('promotionTag', result.promotionTag)
    }
    if (result?.inviter) {
      Local.set('inviter', result.inviter.toString())
    }
    if (result?.curated) {
      Local.set('curated', result.curated)
    }
    /**
     * 落地页
     * p: post
     * c: Creators
     * d: domain
     * r: RewardCenter
     * s: Shares
     */
    console.log('落地页 tg 参数 result', result)
    if (result?.d) {
      router.push({
        name: 'Creators',
        params: {
          domain: result?.d,
        },
      })
    } else if (result?.p) {
      router.push({
        name: 'Post',
        query: {
          id: result?.p,
        },
      })
    } else if (result?.r) {
      router.push({
        name: 'RewardCenter',
      })
    } else if (result?.s) {
      router.push({
        name: 'Shares',
      })
    } else {
      router.replace({ name: 'Home' })
    }
  }

  /**
   * @description 获取用户信息
   * @param params 登录信息 {
   *  token: string;
   *  address: string;
   * }
   */
  const getUserInfo = async (params: any) => {
    try {
      const userStore = useUserStore()
      const loginRes = {
        token: params.token,
        address: params.address,
      }
      Cookie.set('BMS-Authorization', loginRes.token)
      Local.set('BMS-Authorization', loginRes.token)
      const userRes = await baseService.profileInfo(
        {
          addressOrDomain: loginRes?.address,
        },
        {
          headers: {
            Authorization: loginRes.token,
          },
        },
      )
      userStore.INIT({
        info: userRes,
        address: userRes.address,
      })
      userStore.SET_BALANCE_INFO()
      // userStore.GET_PAY_FIXED_FEE()
      if (isTelegram) {
        initTGParams()
      } else {
        clickShareLink()
      }
    } catch (error) {
      console.error(error)
    } finally {
      _loadingInstance.close()
    }
  }

  /**
   * @description telegram 登录
   */
  const tgLogin = async () => {
    try {
      _loadingInstance.open({
        content: 'Login...',
      })
      const curated = Local.get('curated')
      const res = await walletService.tgLogin({
        initData: telegramWebApp?.initData,
        promoteKey: curated || undefined,
      })
      if (res.token) {
        if (res?.info?.firstLogin) {
          return GlobalThis.$welcome?.open()
        } else {
          GlobalThis.$getRewards?.open()
        }
        Local.set('loginType', 4)
        Local.remove('curated')
        getUserInfo({
          token: res.token,
          address: res.info.address,
        })
        initTGParams()
      }
    } catch (error) {
      console.error(error)
    } finally {
      _loadingInstance.close()
    }
  }

  /**
   * @description 设置请求头参数
   */
  const setHeaders = () => {
    const inviter = Local.get('inviter')
    const invitorDomain = Cookie.get('invitorDomain')
    // promotionTag 为运营推广注册标识
    const promotionTag = Local.get('promotionTag')
    const headers: any = {}

    if (invitorDomain) {
      headers.invitorDomain = invitorDomain
    }
    if (inviter) {
      headers.inviter = inviter
    }
    if (promotionTag) {
      headers.promotionTag = promotionTag
    }

    return headers
  }

  /**
   * @description 登录
   */
  const userLogin = async (data: any, type: number) => {
    try {
      const curated = Local.get('curated')
      const fromDomain = Cookie.get('fromDomain')
      const headers = setHeaders()
      if (curated) {
        data.promoteKey = curated
      }
      _loadingInstance.open({
        content: 'Login...',
      })
      // type 0 - wallet 1 - email 2 - twitter 3 - google 5 - password
      const loginRes: LoginResult =
        type === 5
          ? await walletService.emailPasswordLogin({ ...data, fromDomain, type }, { headers })
          : await walletService.login(
              {
                ...data,
                type,
                fromDomain,
              },
              {
                headers,
              },
            )
      const shareInfo = window.sessionStorage.getItem('shareInfo')
      if (shareInfo) {
        await baseService.clickShareLink(JSON.parse(shareInfo))
        window.sessionStorage.removeItem('shareInfo')
      }

      getUserInfo({
        token: loginRes.token,
        address: loginRes.info.address,
      })
      return {
        success: true,
      }
    } catch (error: any) {
      console.error('userLogin error', error)
      if (type !== 5) {
        GlobalThis.$message?.error(error?.msg || error?.message || error)
      }
      _loadingInstance.close()
      return error
    }
  }

  const authCode2UserInfo = async (authCode: string) => {
    try {
      const userStore = useUserStore()
      const res = await commentService.loginAuthCode(authCode)
      Cookie.set('BMS-Authorization', res.token)
      Local.set('BMS-Authorization', res.token)
      userStore.INIT({
        info: res.info,
        address: res.info.address,
      })
      userStore.SET_BALANCE_INFO()
      // userStore.GET_PAY_FIXED_FEE()
      clickShareLink()
    } catch (error) {
      console.error(error)
    }
  }

  return {
    tgLogin,
    initInvitorDomain,
    userLogin,
    setHeaders,
    clickShareLink,
    loginJump,
    getUserInfo,
    initTGParams,
    authCode2UserInfo,
  }
}
